import { createSlice } from "@reduxjs/toolkit";
import { updateNotification } from "@/api/new-api/utility";

const getLocalStorageBool = (key, defaultVal) => {
  const val = localStorage.getItem(key);
  if (val === null) return defaultVal;
  return val === "true";
};

const initialState = {
  notificationsEnabled: true,
  sales: false,
  volume: 0.7,
  callNotificationSound: getLocalStorageBool("callNotificationSound", true),
  posSound: getLocalStorageBool("posSound", true),
  notificationSound: getLocalStorageBool("notificationSound", true),
};

let debounceTimer = null;

const soundNotificationSlice = createSlice({
  name: "soundNotification",
  initialState,
  reducers: {
    toggleNotifications: (state) => {
      state.notificationsEnabled = !state.notificationsEnabled;
    },
    toggleSales: (state) => {
      state.sales = !state.sales;
    },
    setVolume: (state, action) => {
      state.volume = action.payload;
    },
    toggleCallNotificationSound: (state) => {
      const current = state.callNotificationSound === undefined ? true : state.callNotificationSound;
      state.callNotificationSound = !current;
      localStorage.setItem("callNotificationSound", state.callNotificationSound);
    },
    togglePosSound: (state) => {
      const current = state.posSound === undefined ? true : state.posSound;
      state.posSound = !current;
      localStorage.setItem("posSound", state.posSound);
    },
    toggleNotificationSound: (state) => {
      const current = state.notificationSound === undefined ? true : state.notificationSound;
      state.notificationSound = !current;
      localStorage.setItem("notificationSound", state.notificationSound);
    },
  },
});

export const {
  toggleNotifications,
  toggleSales,
  setVolume,
  toggleCallNotificationSound,
  togglePosSound,
  toggleNotificationSound,
} = soundNotificationSlice.actions;

export const updateNotificationSettings =
  (data) => async (dispatch, getState) => {
    if (debounceTimer) clearTimeout(debounceTimer);

    debounceTimer = setTimeout(async () => {
      try {
        const res = await updateNotification(data);
        console.log("Notification settings updated:", res);
      } catch (error) {
        console.error(" Notification update failed:", error);
      }
    }, 500);
  };

export default soundNotificationSlice.reducer;
